import { useTranslation } from "react-i18next";
import ShipmentUpdateIcon from "../../../../icons/shipmentUpdateIcon";
import ShipmentDeliveredIcon from "../../../../icons/shipmentDeliveredIcon";
import { Link } from "react-router-dom";

const Notification = () => {
  const notifications = [
    {
      id: 1,
      type: "statusUpdate",
      message: "تم تحديث حالة الشحنة #ORDERID02 إلى “في الميناء”",
      time: "3:30 PM",
      title: "تحديث حالة الشحنة",
    },
    {
      id: 2,
      type: "delivered",
      message: "تم تسليم الشحنة #ORDERID01 بنجاح إلى العميل",
      time: "1 AM",
      title: "تم تسليم الشحنة",
    },
  ];
  const { t } = useTranslation();
  return (
    <div className="w-full p-5 capitalize bg-white lg:w-auto rounded-2xl">
      <h2 className="py-5 text-2xl font-bold border-b border-b-black">
        {t("notifications")}
      </h2>
      {notifications.map((n, i) => {
        const color =
          n.type === "statusUpdate"
            ? "bg-[#EFF6FF]"
            : n.type === "delivered"
            ? "bg-[#F0FDF4]"
            : "";
        const icon =
          n.type === "statusUpdate" ? (
            <ShipmentUpdateIcon />
          ) : n.type === "delivered" ? (
            <ShipmentDeliveredIcon />
          ) : (
            ""
          );
        return (
          <div key={i} className="py-5 border-b border-b-black">
            <div className={`flex gap-4 p-5 rounded-xl ${color}`}>
              <div>{icon}</div>
              <div>
                <h2 className="text-xl font-medium">{n.title}</h2>
                <p className="text-lg text-mainGray">{n.message}</p>
                <span className="text-[10px] text-mainGray">{n.time}</span>
              </div>
            </div>
          </div>
        );
      })}
      <Link
        className="block py-4 text-xl font-medium text-center text-mainBlue"
        to={"/employee/dashboard/notifications"}
      >
        {t("showMore")}
      </Link>
    </div>
  );
};

export default Notification;
